module.exports = __webpack_public_path__ + "static/media/6.7fdce72e.jpg";